"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.find");

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.includes");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PickList = _interopRequireDefault(require("../PickList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AgencyPickList = /*#__PURE__*/function (_React$Component) {
  _inherits(AgencyPickList, _React$Component);

  var _super = _createSuper(AgencyPickList);

  function AgencyPickList(props) {
    var _this;

    _classCallCheck(this, AgencyPickList);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_getFilteredValue", function (selected) {
      if (selected && _typeof(selected) === 'object') {
        return selected;
      }

      return {
        label: '',
        value: ''
      };
    });

    _defineProperty(_assertThisInitialized(_this), "_renderAgencies", function (agencies) {
      return agencies.map(function (agency) {
        return {
          label: agency.name,
          value: agency.id
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleResultSelect", function (selected) {
      // When the user selects an option the selected is an object like {label, value}
      // but when the user backspaces their string the selected is null, hence the check
      var value = _this._getFilteredValue(selected);

      _this.props.onChange(value);

      _this.setState({
        value: value,
        searchValue: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleInputChange", function (newInput) {
      if (newInput.length < 1 && !_this.state.hideDropdown) {
        _this.setState({
          hideDropdown: true
        });
      }

      if (newInput.length >= 1 && _this.state.hideDropdown) {
        _this.setState({
          hideDropdown: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_filterResults", function (options, filterString) {
      // Convert both to lowercase and then check whether the label includes the filter string
      // returns only the 8 first results (sorted alphabetically)
      return options.filter(function (option) {
        return option.label.toLowerCase().includes(filterString.toLowerCase());
      }).slice(0, 8);
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (e) {
      // adding blur event to the picklist
      e.target.addEventListener('blur', _this._onBlur, false);

      _this.props.onFocus(e);
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (e) {
      var agencies = _this.props.agencies;
      var searchValue = _this.state.searchValue;
      var currentTargetValue = e.target.value;

      if (currentTargetValue) {
        // test if search value matches exactly to an option
        var found = agencies.find(function (o) {
          return o.label === currentTargetValue;
        });
        var value = found || {
          value: searchValue,
          label: currentTargetValue
        };

        _this.props.onChange(value);

        _this.setState({
          value: value,
          searchValue: ''
        });
      }

      _this.props.onBlur(e);
    });

    _this.state = {
      hideDropdown: true,
      isLoading: false,
      value: _this._getFilteredValue(),
      agencies: [],
      searchValue: null
    };
    return _this;
  }

  _createClass(AgencyPickList, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          hideDropdown = _this$state.hideDropdown,
          isLoading = _this$state.isLoading;
      var _this$props = this.props,
          agencies = _this$props.agencies,
          noAgenciesText = _this$props.noAgenciesText;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "ctrl-holder agency-picklist"
      }, /*#__PURE__*/_react.default.createElement(_PickList.default, _extends({}, this.props, {
        clearable: true,
        filterFunc: this._filterResults,
        hideDropdown: hideDropdown,
        isLoading: isLoading,
        listOptions: this._renderAgencies(agencies),
        noResultsText: /*#__PURE__*/_react.default.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: noAgenciesText
          }
        }),
        onInputChange: this._handleInputChange,
        onInputFocus: this._onFocus,
        onResultSelect: this._handleResultSelect,
        required: true,
        resetInput: false
      })));
    }
  }]);

  return AgencyPickList;
}(_react.default.Component);

exports.default = AgencyPickList;

_defineProperty(AgencyPickList, "propTypes", {
  onChange: _propTypes.default.func.isRequired,
  onFocus: _propTypes.default.func.isRequired,
  onBlur: _propTypes.default.func.isRequired,
  agencies: _propTypes.default.array.isRequired,
  noAgenciesText: _propTypes.default.string.isRequired,
  helpText: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]).isRequired
});

_defineProperty(AgencyPickList, "defaultProps", {
  helpText: null
});
//# sourceMappingURL=AgencyPickList.js.map